import React, { useState } from 'react';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import logoAutofactWhite from '../assets/img/logoAutofactWhite.svg';
import download from '../assets/img/download.svg';
import { apiBaseUrl, authorizationCookie, redirectUrlConces } from '../config/config';
import { BlankSpace } from '../genericComponents/layouts';

interface HeaderProps {
  withActions?: boolean;
  id?: string;
  createdAt?:string;
  urlReport?:string;
  loaded?:boolean;
  resultsDate?:string;
  isPublicReport?:boolean;
}

async function redirectPrecio() {
  window.open(redirectUrlConces, '_blank', 'noopener,noreferrer');
}

export default function Header({
  withActions = true,
  id = '0',
  createdAt = '',
  urlReport = '',
  loaded = false,
  resultsDate = '',
  isPublicReport = false,
}: Readonly<HeaderProps>) {
  let generatingReport = 0;
  const buttonText = {
    loading: 'Generando PDF...',
    generate: 'Descargar informe PDF',
  };
  const [currentText, setCurrentText] = useState(buttonText.generate);

  async function exportPriceReport() {
    if (generatingReport === 0) {
      generatingReport = 1;
      setCurrentText(buttonText.loading);
      if (urlReport && urlReport !== '') {
        window.open(urlReport, '_blank', 'noopener,noreferrer');
      } else {
        await fetch(`${apiBaseUrl}/export/price-report/${id}?jwt=${Cookies.get(authorizationCookie)}`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        }).then((response) => response.json())
          .then((data) => {
            console.log(data);
            window.open(data.data, '_blank', 'noopener,noreferrer');
          }).catch((err) => console.log(err));
      }
      setCurrentText(buttonText.generate);
      generatingReport = 0;
    }
  }

  return (
    <Container>
      <DSKSubContainer>
        <ButtonWrapper>
          <img height={38} src={logoAutofactWhite} alt="autofact" />
        </ButtonWrapper>
        <RightGroup>
          <DSKContainer3>
            <SpacerContainer>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Text3>Código: </Text3>
                <BlankSpace width="2px" />
                <Text3B>{id}</Text3B>
              </div>
            </SpacerContainer>
          </DSKContainer3>
          <BlankSpace height="10px" width="10px" />
          <ButtonWrapper>
            {loaded && createdAt && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Text3>Fecha de emisión: </Text3>
                <BlankSpace width="2px" />
                <Text3B>{createdAt}</Text3B>
              </div>
            )}
            {loaded && resultsDate && !isPublicReport && (
              <>
                <BlankSpace height="10px" width="10px" />
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <Text3>Fecha de resultados: </Text3>
                  <BlankSpace width="2px" />
                  <Text3B>{resultsDate}</Text3B>
                </div>
              </>
            )}
          </ButtonWrapper>
          { withActions && loaded
            ? (
              <DSKContainer3>
                <SpacerContainer>
                  <Enlace onClick={() => exportPriceReport()}>
                    <img height={16} src={download} alt="Descargar" />
                    <BlankSpace width="4px" />
                    {currentText}
                  </Enlace>
                  <TextButton onClick={() => redirectPrecio()}>Volver a Buscar</TextButton>
                </SpacerContainer>
              </DSKContainer3>
            ) : '' }
        </RightGroup>
      </DSKSubContainer>
    </Container>
  );
}

const RightGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: right;
`;
const Text3 = styled.label`
  font-size: 12px;
  color: #fff;
`;
const Text3B = styled.label`
  font-size: 12px;
  color: #fff;
  font-family: 'Roboto bold';
`;
const Container = styled.div`
  padding: 16px;
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #004CC6;
`;
const DSKSubContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 700px){
    flex-direction: column;
  }
`;
const ButtonWrapper = styled.button`
  background: none;
  border: none;
  outline: none;
  color: #fff;
  display: flex;
  flex-direction: row;
  padding-right: 10px;
  align-items: flex-end;
  justify-content: flex-end;
  @media (max-width: 700px){
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding-top: 20px;
  }
`;
const DSKContainer3 = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  @media (max-width: 700px){
    justify-content: center;
    padding-top: 20px;
  }
`;
export const SpacerContainer = styled.div`
  display: flex;
  padding: 0px;
  margin: 10px 10px 0 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  @media (max-width: 700px){
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
`;
const TextButton = styled.button`
  color: #FFA401;
  font-size: 16px;
  font-family: 'Roboto bold';
  padding: 5px 0px 0px 0px;
`;
const Enlace = styled.a`
  color: #fff;
  font-weight: lighter;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
`;
